export const languageObject = [
    {
        label: 'English',
        code: 'en',
    },
    {
        label: 'Swedish',
        code: 'sv',
    },
    // {
    //     label: 'French',
    //     code: 'fr',
    // },
    // {
    //     label: 'German',
    //     code: 'de',
    // },
    // {
    //     label: 'Polish',
    //     code: 'pl',
    // },
    // {
    //     label: 'Italian',
    //     code: 'it',
    // },
    // {
    //     label: 'Finnish',
    //     code: 'fi',
    // },
    // {
    //     label: 'Spanish',
    //     code: 'es',
    // },
    // {
    //     label: 'Danish',
    //     code: 'da',
    // },
    // {
    //     label: 'Norwegian',
    //     code: 'no',
    // },
    // {
    //     label: 'Greek',
    //     code: 'el',
    // },
];

export function removeLanguageFromPathname(pathname: string): string {
    // Regular expression to match the leading language code segment
    // This matches a leading slash, followed by two lowercase letters, followed by another slash
    const langPrefixRegex = /^\/[a-z]{2}\//;

    // Check if the pathname starts with a language code
    if (langPrefixRegex.test(pathname)) {
        // Remove the language code and return the modified pathname
        return pathname.replace(langPrefixRegex, '/');
    }

    // If there's no language code, return the original pathname
    return pathname;
}
